(function($, window) {
	/**
	* Create Rating Star
	* @note This need to work with Font Awesome Pro
	* @since 2019-04-18
	* @param {Number} points The points value
	* @param {Number} maximum The maximum value
	*/
	var GenerateStars = (points, maximum) => {
		var full = new Array(Math.floor(points + 1)).join('<i class="fas fa-fw fa-star"></i>');
		var half = points % 1 !== 0 ? '<i class="fas fa-fw fa-star-half-alt"></i>' : '';
		var none = new Array(Math.floor(maximum + 1 - points)).join('<i class="far fa-fw fa-star"></i>');
		return full+half+none;
	}

	var _el = document.querySelectorAll('[data-rating]');
	_el.forEach(el => {
		var pts = Number(el.dataset.rating);
		var max = Number(el.dataset.ratingMax) || 5;
		el.innerHTML = GenerateStars(pts, max);
	});

	$.extend(true, window.TL, {
		ui: {
			star: GenerateStars
		}
	});
})(jQuery, window);